<template>
    <div class="ssq-why">
        <h5>Why insure with us</h5>
        <ul class="ssq-why-list">
            <li>Established over 25 years</li>
            <li>24 hr legal advice helpline</li>
            <li>Access to legal document hub</li>
            <li>Instant policy documents</li>
            <li>Dedicated claims services</li>
            <li>Easy payment options</li>
        </ul>
    </div>
</template>
